import { AxiosHttpClient } from 'src/infra/http/axios-http-client-open/axios-http-client-open'
import { settings } from '../../configs/settings'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const makeAxiosHttpClient = () => new AxiosHttpClient(settings.API_URL)
